'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import invariant from 'tiny-invariant';
import { getNextApiRoute, typedFetch } from '../../utils';
type OneTrustTokenResponse = {
  success: boolean;
  message: string;
  token?: string;
};

/**
 * Hook to initialize OneTrust parameters.
 * Here we generate JWT and form a string to be inserted into the script.
 * All code is executed on the client, after rendering.
 */
export const useOneTrustParams = t0 => {
  const $ = _c(5);
  const {
    customerKey
  } = t0;
  const [token, setToken] = useState("");
  let t1;
  let t2;
  if ($[0] !== customerKey) {
    t1 = () => {
      if (!customerKey) {
        return;
      }
      typedFetch(getNextApiRoute(`onetrust/generate-token/${customerKey}`)).then(response => {
        invariant(response?.token, `RequestNewToken failed: ${response?.message}`);
        setToken(response.token);
      }).catch(_temp);
    };
    t2 = [customerKey];
    $[0] = customerKey;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== token) {
    t3 = {
      token
    };
    $[3] = token;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
function _temp(error) {
  console.error("OneTrust token fetch failed:", error);
}